import React, { useState, useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { formatCurrency } from '../shared/utils'
import { formatDate } from '../shared/utils'
import { useContext } from 'react'
import { AuthenticationContext } from '../../Auth/authentication.context'
import originsDirect from '../../assets/images/ORIGINS-DIRECT.png'
// import originsManagement from '../../assets/images/ORIGINS-MANAGEMENT.png'
import originsDirectInstant from '../../assets/images/ORIGINS-DIRECT-INSTANT.png'
import Modals from '../shared/Modals'
import server from '../../server'
import { Message } from 'primereact/message'

export default function ManufacturerOrderDetailsHeader(props) {
  const [order] = useState([props.order])
  const [total, setTotal] = useState(null)
  const [paymentModalVisible, setPaymentModalVisible] = useState(false)
  const [paymentDetails, setPaymentDetails] = useState(null)
  const [paymentLoading, setPaymentLoading] = useState(false)

  useEffect(() => {
    if (props?.total) {
      setTotal(props?.total)
    }
  }, [props.total])

  const fetchPaymentDetails = async (pharmacyId) => {
    if (!pharmacyId) return

    setPaymentLoading(true)
    try {
      const response = await server.get(
        `/payments/pharmacy-payment-profile/${pharmacyId}`
      )
      setPaymentDetails(response.data)
      setPaymentLoading(false)
    } catch (error) {
      console.error('Error fetching payment details:', error)
      setPaymentLoading(false)
    }
  }

  const totalInvoiceBodyTemplate = (order) =>
    formatCurrency(
      total !== null && ['Confirmed', 'Received'].includes(props?.status)
        ? formatCurrency(total)
        : props?.status === 'Cancelled'
        ? formatCurrency(0.0)
        : formatCurrency(order?.totalInvoiceAmount)
    )
  const orderDateBodyTemplate = (order) => formatDate(order.orderDate)

  const statusBodyTemplate = (order) => {
    let statusColor
    let textColor
    let status
    if (props.status) {
      status = props.status
    } else {
      status = order.status
    }
    switch (status) {
      case 'Cancelled':
        statusColor = '#EF4444'
        textColor = '#EF4444'
        break
      case 'Pending':
        statusColor = '#86888b'
        textColor = '#86888b'

        break
      case 'Confirmed':
        statusColor = '#22c55e'
        textColor = '#22c55e'
        break
      default:
        statusColor = '#86888b'
        textColor = '#86888b'
        break
    }

    return (
      <span
        className={`d-flex justify-content-center py-1 rounded-pill`}
        style={{ border: `1px solid ${statusColor}`, color: `${textColor}` }}
      >
        {status}
      </span>
    )
  }

  const systemBodyTemplate = (order) => {
    const handlePaymentClick = (e) => {
      e.stopPropagation()
      // Fetch payment details for the pharmacy associated with this order
      fetchPaymentDetails(order.pharmacy?.id)
      setPaymentModalVisible(true)
    }

    let systemLogo
    let systemName

    if (order.system === 'Origins Direct Instant') {
      systemLogo = originsDirectInstant
      systemName = 'Origins Direct Instant'
    } else {
      systemLogo = originsDirect
      systemName = 'Origins Direct'
    }

    return (
      <div className='d-flex justify-content-center align-items-center'>
        <img
          src={systemLogo}
          alt={systemName}
          style={{ height: '20px' }}
          className='me-2'
        />
        {order.system === 'Origins Direct Instant' && (
          <i
            className='mdi mdi-credit-card-outline ml-2'
            style={{
              marginLeft: '10px',
              cursor: 'pointer',
              fontSize: '18px',
              color: '#626ED4',
            }}
            onClick={handlePaymentClick}
          ></i>
        )}
      </div>
    )
  }

  return (
    <>
      <div className='card mb-5'>
        <DataTable
          showGridlines
          value={order}
          tableStyle={{ minWidth: '50rem' }}
        >
          <Column header='Pharmacy Name' rowSpan={2} field='pharmacy.name' />
          <Column
            header='Account Number'
            rowSpan={2}
            hidden={
              props.order?.supplier?.name === 'Origins Direct' ? true : false
            }
            field='customerAccountCode'
          />
          <Column header='Order Number' rowSpan={2} field='supplierOrderNo' />
          <Column
            header='Order Date'
            rowSpan={2}
            field='orderDate'
            body={orderDateBodyTemplate}
          />
          <Column header='System' field='system' body={systemBodyTemplate} />
          <Column header='Status' field='status' body={statusBodyTemplate} />
          <Column
            header='Order Total'
            rowSpan={2}
            field='totalInvoiceAmount'
            body={totalInvoiceBodyTemplate}
          />
        </DataTable>
      </div>

      {/* Payment Modal */}
      <Modals
        ModalHeader='Payment Information'
        btnName='Close'
        visible={paymentModalVisible}
        setVisible={setPaymentModalVisible}
        onButtonClick={() => setPaymentModalVisible(false)}
        width='40rem'
      >
        {paymentLoading ? (
          <div className='text-center my-3'>
            <div className='spinner-border text-primary' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
            <p className='mt-2'>Loading payment details...</p>
          </div>
        ) : (
          <div>
            <div className='mb-3'>
              <p>
                {order[0]?.pyNumber
                  ? `Card ending in ${order[0]?.pyNumber}`
                  : paymentDetails?.cardNumber
                  ? `Card ending in ${paymentDetails.cardNumber.replace(
                      'XXXX',
                      '****'
                    )}`
                  : 'No payment information available'}
              </p>
            </div>

            <div className='small text-muted mt-3'>
              <Message
                severity='info'
                content='For security reasons, complete payment details are not displayed.'
              />
            </div>
          </div>
        )}
      </Modals>
    </>
  )
}
